import styled from 'styled-components'
import Icon from '@/components/icon'
import { createModal, useModalize } from '@/components/modalize'
import { breakpoints } from '@/styles'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px;
  max-height: 95vh;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 25px 10px;
  }
`

const ContentWrapper = styled.div`
  flex: 1;
  overflow: auto;
`

const CloseButton = styled(Icon)`
  position: absolute;
  z-index: 1;
  cursor: pointer;
  top: 0px;
  right: 5px;
  height: 52px;
  width: 52px;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    top: 5px;
    right: -5px;
    height: 40px;
    width: 40px;
  }
`

const ModalPdf = styled.iframe`
  width: 85vw;
  height: 75vw;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    height: 160vw;
  }
`

const PdfModal = ({ src }) => {
  const { close } = useModalize()
  return (
    <Wrapper>
      <CloseButton aria-label="Close" id="close_button" onClick={close} />
      <ContentWrapper>
        <ModalPdf src={src} data-hj-suppress />
      </ContentWrapper>
    </Wrapper>
  )
}

export const showPdfModal = createModal(PdfModal, {
  showBackground: false,
  width: 'auto'
})
